/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailVerificationResponse } from '../../models/email-verification-response';

export interface ConfirmEmailVerification$Params {

/**
 * Hash from email.
 */
  hash: string;
}

export function confirmEmailVerification(http: HttpClient, rootUrl: string, params: ConfirmEmailVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailVerificationResponse>> {
  const rb = new RequestBuilder(rootUrl, confirmEmailVerification.PATH, 'post');
  if (params) {
    rb.path('hash', params.hash, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmailVerificationResponse>;
    })
  );
}

confirmEmailVerification.PATH = '/rest/email-verification/{hash}/confirm';
